/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import LinkDialogButton from "./link-dialog-button";
import { useTheme } from "@mui/material/styles";

const AddLinkButton = (props) => {
    const { setOpen } = props;
    const theme = useTheme();

    return (
        <Fragment>
            <div
                style={{
                    width: "100%",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    border: "1px solid #CECECE",
                    borderRadius: "4px",
                    color: "#7A7A7A",
                    padding: "16px",
                }}
            >
                <LinkDialogButton setOpen={setOpen} color={theme.palette.primary.main} />
            </div>
        </Fragment>
    );
};
export { AddLinkButton };
